module.exports = __webpack_public_path__ + "img/5.fc934a25.png";